<template>
	<div class="flex w-full">
		<span v-for="i in 5" :key="i"
		      :class="{ 'mr-1': i < 5, 'active': modelValue * 5 >= i, 'inactive': modelValue * 5 < i }">
   <svg style="fill: currentColor"
        class="tw-block w-full"
        viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
		    d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
   </svg>
  </span>
	</div>
</template>

<script lang="ts" setup>

defineProps<{
	modelValue?: number
}>()
</script>

<style scoped>
svg {
	width: 20px;
	height: 20px;
}

.active {
	@apply text-yellow-400;
}

.inactive {
	@apply text-yellow-200;
}
</style>
